import { ReactNode } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  subSide?: ReactNode
}

const ModalFooter = ({ children, subSide }: Props) => {
  return (
    <>
      <div
        className={clsx(
          'bg-fill-primary relative flex items-center justify-between gap-x-4 rounded-b-2xl p-4',
          'border-secondary border-t'
        )}
      >
        {subSide && <div>{subSide}</div>}
        <div className='ml-auto flex gap-x-2'>{children}</div>
      </div>
    </>
  )
}

export default ModalFooter
